import styled from 'styled-components';
import { Button } from '../Button';
import { TypesButton } from '../../constants/ButtonTypes';
import { units } from '../../helpers/styles/units';
import { FaqActionsMenu } from './FaqActionsMenu';
import { PageStatus } from './types';
import type { FaqItem, FaqStatus } from './types';

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: ${units(16)};
`;

const StyledTh = styled.th`
  text-align: left;
  padding: ${units(8)};
  border-bottom: 1px solid #e5e5e5;
`;

const StyledTd = styled.td`
  padding: ${units(8)};
  border-bottom: 1px solid #f0f0f0;
  vertical-align: top;
`;

type Props = {
    list: FaqItem[];
    onDelete: (id: number) => void;
    changePage: (status: PageStatus, data?: FaqItem | null) => void;
};

const getStatus = (status: FaqStatus) => {
    switch (status) {
        case 'ACTIVE' as FaqStatus:
            return 'Активный';
        case 'INACTIVE' as FaqStatus:
            return 'Неактивный';
        default:
            return 'Неизвестный статус';
    }
};

export const FaqTablePage = ({ list, onDelete, changePage }: Props) => (
    <>
        {list.length <= 10 && (
            <Button typeButton={TypesButton.PRIMARY} onClick={() => changePage(PageStatus.ADD)}>
                Добавить FAQ
            </Button>
        )}
        <StyledTable>
            <thead>
                <tr>
                    <StyledTh>Вопрос</StyledTh>
                    <StyledTh>Статус</StyledTh>
                    <StyledTh>Порядок</StyledTh>
                    <StyledTh>Действия</StyledTh>
                </tr>
            </thead>
            <tbody>
                {list.map(item => (
                    <tr key={item.id}>
                        <StyledTd>{item.question}</StyledTd>
                        <StyledTd>{getStatus(item.status)}</StyledTd>
                        <StyledTd>{item.order ?? '-'}</StyledTd>
                        <StyledTd>
                            <FaqActionsMenu
                                onEdit={() => changePage(PageStatus.EDIT, item)}
                                onDelete={() => onDelete(item.id)}
                            />
                        </StyledTd>
                    </tr>
                ))}
            </tbody>
        </StyledTable>
    </>
);
